import { defineComponent as _defineComponent } from 'vue'
import { Routes } from '@/router/routes';
import { User } from '@/models/user';
import LanguageSelectorModal from './language/LanguageSelectorModal.vue';
import { getLocaleFullName } from '@/locale/dictLocale';
import {
  canAccessBusinessConsole,
  canAccessEServiceCenter,
  canAccessShopFloorConsole,
  canAccessTechnologyConsole,
  canAccessWorkCenterConsole,
} from '@/utils/permissionUtils';

import { BysoftSidebar, BysoftSidebarEntry } from '@/components/common/sidebar';
import { usersService } from '@/services/users.service';
import { devicesService } from '@/services/devices.service';
import { isEmpty } from '@/utils/misc';
import { currentLocale } from '@/utils/i18n';
import { computed, getCurrentInstance, ref } from 'vue';
import { useRoute, useRouter } from '@/composables/router';
import { modalService } from '@/library-services/modal.service';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN
 * Provides the application menu to access the different pages and the language
 * selector.
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SidebarLayout',
  setup(__props, { expose }) {

const sidebarRef = ref<InstanceType<typeof BysoftSidebar>>();

const route = useRoute();
const router = useRouter();
const { t } = useI18n();

function isRouteActive(path: string): boolean {
  if (path === '/') {
    // all routes include '/', so use === in this case
    return route.value.path === path;
  }
  return route.value.path.startsWith(path.replace('overview', ''));
}

function routeTo(routeTo: Routes) {
  if (route.value.name !== routeTo) {
    router.push({ name: routeTo });
  }
}

const app = getCurrentInstance();
function openSelectLanguage() {
  modalService.compositionApi.open(
    {
      component: LanguageSelectorModal,
      customClass: 'language-selector-modal',
    },
    app,
  );
}

function toggle() {
  sidebarRef.value?.toggle();
}

const canAccessDashboard = computed(
  (): boolean => !(user.value.isTechnologyUser || user.value.isServiceUserType),
);

const user = computed((): User => usersService.store.current());

const showCut = computed(
  (): boolean =>
    user.value.hasCustomer && !isEmpty(devicesService.store.cutDevices()),
);

const showBend = computed(
  (): boolean =>
    user.value.hasCustomer && !isEmpty(devicesService.store.bendDevices()),
);

const showTube = computed(
  (): boolean =>
    user.value.hasCustomer && !isEmpty(devicesService.store.tubeDevices()),
);

const showWorkCenterConsole = computed(
  (): boolean =>
    canAccessWorkCenterConsole() &&
    (showCut.value || showBend.value || showTube.value),
);

const fullLocaleName = computed(() => getLocaleFullName(currentLocale()));

expose({ toggle });

return { __sfc: true,sidebarRef, route, router, t, isRouteActive, routeTo, app, openSelectLanguage, toggle, canAccessDashboard, user, showCut, showBend, showTube, showWorkCenterConsole, fullLocaleName, Routes, canAccessBusinessConsole, canAccessEServiceCenter, canAccessShopFloorConsole, canAccessTechnologyConsole, BysoftSidebar, BysoftSidebarEntry }
}

})